'use client'

import { useState, type JSX } from 'react'

import dynamic from 'next/dynamic'
import Image from 'next/image'

import Button from '@components/buttons/button'

import menuIcon from '@images/navbar/icon_burger.svg'
import searchIcon from '@images/navbar/icon_field-search.svg'

import styles from './links.module.scss'
import Link from 'next/link'

// No `ssr: false`: on Next 16 it remounts the component whenever this parent re-renders, so the
// modal that the click just opened is torn down and rebuilt closed — the menu and the search both
// stopped opening. Plain `dynamic()` keeps the separate chunk without the remount. [S20-865]
const Menu = dynamic(() => import('@components/layout/layout/menu'))
const Search = dynamic(() => import('@components/layout/layout/search'))
type NavbarProps = {
  variant?: 'default' | 'simple'
}

function Links({ variant }: NavbarProps): JSX.Element {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)
  const [isSearchOpen, setIsSearchOpen] = useState<boolean>(false)

  if (variant === 'default') {
    return (
      <div className={styles.links}>
        <ul className={styles['links-desktop']}>
          <li className={styles['link-item']}>
            <Button
              variant="simple-text"
              size="full"
              data-pw="navbar-search"
              onClick={(): void => setIsSearchOpen(true)}
            >
              <Image src={searchIcon} alt="Search icon" width={20} height={20} />
              Search
            </Button>
          </li>
          <li className={styles['link-item']}>
            <Link href="/jobs">Browse Jobs</Link>
          </li>
          <li className={styles['link-item']}>
            <Button variant="simple-text" size="full" data-pw="navbar-menu" onClick={(): void => setIsMenuOpen(true)}>
              {/* icon_burger.svg is 22x16 (ratio 1.375); minireset's global `img { height: auto }`
              already renders it at that ratio, so 20 (the old prop) never matched what was on
              screen. 15 = round(20 / 1.375), the actual rendered height. [S20-865] */}
              <Image src={menuIcon} alt="Search icon" width={20} height={15} />
              More
            </Button>
          </li>
        </ul>
        <ul className={styles['links-mobile']}>
          <li className={styles['link-item']}>
            <Button
              variant="simple-text"
              size="full"
              data-pw="navbar-search"
              onClick={(): void => setIsSearchOpen(true)}
            >
              <Image src={searchIcon} alt="Search icon" width={20} height={20} />
            </Button>
          </li>
          <li className={styles['link-item']}>
            <Button variant="simple-text" size="full" data-pw="navbar-menu" onClick={(): void => setIsMenuOpen(true)}>
              {/* icon_burger.svg is 22x16 (ratio 1.375); minireset's global `img { height: auto }`
              already renders it at that ratio, so 20 (the old prop) never matched what was on
              screen. 15 = round(20 / 1.375), the actual rendered height. [S20-865] */}
              <Image src={menuIcon} alt="Search icon" width={20} height={15} />
            </Button>
          </li>
        </ul>
        <Search isOpen={isSearchOpen} close={(): void => setIsSearchOpen(false)} />
        <Menu isOpen={isMenuOpen} close={(): void => setIsMenuOpen(false)} />
      </div>
    )
  }
  return <></>
}

export default Links
